import { render } from "./MainComponent.vue?vue&type=template&id=54d25e4a"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"

import "./MainComponent.vue?vue&type=style&index=0&id=54d25e4a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__